import { SET_HOMEPAGE_ARTICLES } from './types'
import { AppDispatch, RootState } from 'redux/store';
import { CAArticle } from '../../interfaces/ca';

export const setHomepageArticles = (homepageArticles: CAArticle[]) => {
  return (dispatch: AppDispatch, getState: () => RootState) => {
    if (getState().ca.homepageArticles !== homepageArticles) {
      dispatch({
        type: SET_HOMEPAGE_ARTICLES,
        homepageArticles
      })
    }
  }
}
